import React from 'react';
import { Link } from 'react-router-dom';

import './MyAccountPopOver.scss';
import LogoutModal from '../LogoutModal/LogoutModal';

const MyAccountPopOver = (props) => {
  const { mouseEnter, mouseLeave, logoutModal, setLogoutModal } = props;

  return (
    <>
      <div onMouseEnter={() => mouseEnter()} onMouseLeave={() => mouseLeave()} className='myacc'>
        <p className='myacc__title'>MY ACCOUNT</p>
        <ul onClick={() => mouseLeave()} className='myacc__list'>
          <li className='myacc__list__item'>
            <Link to='/account'>Profile</Link>
          </li>
          <li className='myacc__list__item'>
            <Link to='/account/transactions'>Balances & Transactions</Link>
          </li>
          <li className='myacc__list__item'>
            <Link to='/account/payment'>Payment Methods</Link>
          </li>
          <li className='myacc__list__item'>
            <Link to='/account/documents'>Documents</Link>
          </li>
          <li className='myacc__list__item'>
            <Link to='/account/settings'>Settings</Link>
          </li>
          <li className='myacc__list__item'>
            <Link to='/account/help-center'>Help Center</Link>
          </li>
          <li className='myacc__list__item'>
            <Link to='/account/legal'>Legal</Link>
          </li>
          <li className='myacc__list__item'>
            <span className='cursor-pointer' onClick={() => setLogoutModal(true)}>
              Log out
            </span>
          </li>
        </ul>
        <LogoutModal logoutModal={logoutModal} setLogoutModal={setLogoutModal} />
      </div>
    </>
  );
};

export default MyAccountPopOver;
